import { useCallback } from 'react'
import { showAlert } from '../../../utility/SweetAlert'
import ApiService from '../../../services/ApiService'
import { useTranslation } from 'react-i18next'
import { DATA_ALREADY_EXIST } from '../../../utility/ResponseConstant'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const InteractorStoreWarehouseFormAction = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { account } = useSelector((state) => state.account)
  const { seller } = useSelector((state) => state.seller)
  const deleteWarehouse = useCallback(
    (payload, callback, loadingCallback = () => {}) => {
      let requestPayload = { ...payload }
      loadingCallback(true)
      ApiService.jsonRequest('/store-warehouse/delete', requestPayload, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_deleted`),
            timer: false,
          })
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
        callback()
      })
    },
    [t],
  )

  const addWarehouse = useCallback(
    (payload, loadingCallback = () => {}) => {
      let warehousePayload = { ...payload, store_uid: seller.uid, created_by: account.full_name }
      loadingCallback(true)
      ApiService.jsonRequest('/store-warehouse/create', warehousePayload, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_added`),
            timer: 2000,
          })
          navigate('/logistic/warehouse')
        } else {
          if (
            response.messages === DATA_ALREADY_EXIST ||
            response.messages === 'warehouse_name_already_exists'
          ) {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 2000,
            })
          } else {
            showAlert({
              icon: 'error',
              message: t(`response_message.internal_server_error`),
              timer: 2000,
            })
          }
        }
      })
    },
    [account.full_name, navigate, seller.uid, t],
  )

  const updateWarehouse = useCallback(
    (payload, loadingCallback = () => {}, callback = () => {}) => {
      let warehousePayload = { ...payload }
      loadingCallback(true)
      ApiService.jsonRequest('/store-warehouse/update', warehousePayload, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_updated`),
            timer: 2000,
            redirect: '/logistic/warehouse',
          })
        } else {
          if (response.messages === DATA_ALREADY_EXIST) {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 2000,
            })
          } else {
            showAlert({
              icon: 'error',
              message: t(`response_message.internal_server_error`),
              timer: 2000,
            })
          }
        }
      })
    },
    [t],
  )

  return { addWarehouse, deleteWarehouse, updateWarehouse }
}

export default InteractorStoreWarehouseFormAction
